import { useTranslation } from "react-i18next";
import { EmailAlias, TeamUser, Workflow } from "../interfaces";
import useUser from "../hooks/useUser";
import { Popover } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";

type Props = {
  sender: TeamUser,
  senderAlias?: EmailAlias,
  onChange: (value: TeamUser) => void,
  workflow: Workflow;
  allowEditing?: boolean;
}

function EmailEditorSender(props: Props) {
  const { user } = useUser();
  const { sender, senderAlias, onChange, workflow } = props;
  const { t } = useTranslation();

  const allowEditing = props.allowEditing && !!workflow.team;

  if (!user)
    return null;

  function onChangeSender(teamUser: TeamUser) {
    onChange(teamUser);
  }

  return (
    <div className="flex items-center w-full relative">
      <label className="w-20 font-gilroy font-medium text-gray-500" htmlFor="email-from">{t("Sender")}</label>
      <Popover className="relative">
        <Popover.Button className='flex items-center gap-2 bg-gray-100 rounded px-2 -ml-2 text-gray-600 font-semibold'>
          {senderAlias
            ? `Alias: ${senderAlias.aliasName} <${senderAlias.aliasEmail}>`
            : `${sender.fullName} <${sender.email}>`
          }
          {allowEditing &&
            <ChevronDownIcon className='w-4 h-4' />
          }
        </Popover.Button>

        <Popover.Panel className="absolute -left-2 top-6 flex flex-col bg-white text-gray-600 shadow rounded text-sm z-40 min-w-[400px]">
          {(!!senderAlias ? [] : workflow.team?.members)?.filter((member: TeamUser) => member.id !== sender.id).map((member: TeamUser) =>
            <Popover.Button key={member.id} className='font-gilroy font-semibold p-2 hover:bg-gray-50 cursor-pointer whitespace-nowrap text-left' onClick={() => onChangeSender(member)}>
              {member.fullName} {"<"}{member.email}{">"}
            </Popover.Button>
          )}
          {!!senderAlias &&
            <div className='px-2 py-1 text-xs text-gray-400 font-semibold'>
              {t("The sender of this email cannot be changed as it is using an alias.")}<br />
              {t("When an alias is selected, emails will always be sent from the Gmail account of the workflow owner.")}
            </div>
          }
        </Popover.Panel>
      </Popover>
    </div>

  );
}

export default EmailEditorSender;
